// extracted by mini-css-extract-plugin
export var infoRow = "_sm-2";
export var labelContainer = "_sm-0";
export var rightInfo = "_sm-1";